import React from "react";

const GOTHIC_D_PATH =
  "M5.81 19.4C5.81 21.3 6.86 22.6 8.95 22.6H9.05C10.18 22.25 10.86 21.97 11.1 21.73C11.55 21.14 11.86 20.69 11.97 20.36L12.03 20.21C12.05 20.14 12.05 20.12 12.05 20.1L11.75 20.4C11.29 20.93 10.14 21.43 9.1 21.43H8.97C7.29 21.43 6.31 20.69 6.31 19.53C6.31 18.47 7.58 17.88 9.08 17.88H9.1C10.55 17.88 12.92 18.32 13.53 18.84C13.71 18.69 14.42 18.23 15.69 17.45C16.95 16.66 17.77 15.99 18.19 15.45L18.14 15.29V8.34C18.14 7.27 18.16 6.47 18.19 5.92C18.19 4.18 16.53 2.88 13.99 2.88H13.55C13.12 2.88 12.4 2.9 11.38 2.92C10.36 2.94 9.55 2.97 8.97 2.97H8.95C8.03 2.75 7.51 2.57 7.36 2.42C7.1 2.23 6.9 1.94 6.77 1.57C6.75 1.49 6.73 1.42 6.71 1.4L6.55 2.64C6.55 4.23 7.31 5.03 8.84 5.03C9.38 5.03 11.9 4.94 12.99 4.94V16.12C11.21 15.75 10.1 15.58 9.64 15.58H9.53C7.42 15.58 5.81 17.51 5.81 19.4ZM13.62 4.94C15.21 4.94 15.99 5.49 15.99 6.55V7.92C15.73 8.55 15.34 8.86 14.84 8.86C14.25 8.86 13.84 8.47 13.62 7.68ZM5.88 13.27C6.03 12.68 6.44 12.55 7.55 12.55H8.84C8.84 14.01 8.49 14.99 7.79 15.47C10.29 14.71 10.81 13.86 10.81 10.97V10.51C10.81 10.25 10.75 9.12 10.75 8.79V8.29C10.73 8.03 10.73 7.81 10.73 7.66V7.1C10.71 6.9 10.71 6.77 10.71 6.75C10.71 5.88 10.95 5.38 11.42 5.25C9.77 5.25 8.84 6.16 8.84 7.9H8.62C6.86 7.9 5.88 8.6 5.88 10.62C6.01 10.12 6.55 9.88 7.53 9.88H8.84V10.62H8.6C6.84 10.62 5.88 11.27 5.88 13.27ZM13.62 8.64C13.9 9.1 14.29 9.31 14.84 9.31C15.34 9.31 15.71 9.12 15.99 8.75V12.1C15.69 11.73 15.29 11.53 14.82 11.53C14.29 11.53 13.9 11.73 13.62 12.14ZM13.62 13.03C13.84 12.32 14.23 11.97 14.82 11.97C15.34 11.97 15.73 12.27 15.99 12.9V16.42L15.62 16.47C15.29 16.47 14.62 16.38 13.62 16.23Z";

export default function DefinitionLetterIcon({
  size = 24,
  color = "currentColor",
  strokeWidth: _strokeWidth,
  onClick,
  className,
  style = {},
  ...rest
}) {
  const mergedStyle = Object.assign(
    { width: size, height: size, cursor: onClick ? "pointer" : undefined },
    style
  );

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={color}
      stroke="none"
      onClick={onClick}
      className={className}
      style={mergedStyle}
      aria-hidden={rest["aria-label"] ? undefined : true}
      {...rest}
    >
      <path d={GOTHIC_D_PATH} />
    </svg>
  );
}
